import type { GameWalletItem } from '@/features/finance/services/paymentService';
import { getIconPathForProvider, type GameProvider } from '@/features/games/data/gameProviders';

const normalizeCode = (code: string | undefined | null) =>
  (code || '').toLowerCase().replace(/\s+/g, '').replace(/-/g, '');

/**
 * The game sheet's game for a wallet row (Money, My games): the catalog entry when there is one
 * (tagline, manual deposits), else the wallet's own game data. A health snapshot already merged
 * into the row (`depositsOpen`) wins over the catalog's.
 */
export function sheetGameForWallet(
  item: GameWalletItem & { depositsOpen?: boolean },
  catalog: GameProvider[] = []
): GameProvider {
  const game = item.game;
  const fromCatalog =
    catalog.find((p) => p.id === game.id) ??
    (game.code ? catalog.find((p) => normalizeCode(p.code) === normalizeCode(game.code)) : undefined);
  const base: GameProvider = fromCatalog ?? {
    id: game.id,
    code: normalizeCode(game.code),
    name: game.name,
    tagline: '',
    icon: getIconPathForProvider(game.code || ''),
    status: game.status,
  };
  return item.depositsOpen === undefined ? base : { ...base, depositsOpen: item.depositsOpen };
}

/** The player's wallet row for a catalog game (by id, then by code), if any. */
export function walletForGame(game: GameProvider, wallets: GameWalletItem[]): GameWalletItem | null {
  return (
    wallets.find((w) => w.game?.id === game.id) ??
    (game.code ? wallets.find((w) => normalizeCode(w.game?.code) === normalizeCode(game.code)) : undefined) ??
    null
  );
}
